// extracted by mini-css-extract-plugin
module.exports = {"repaymentRate":"index-module_repaymentRate_R5Cal","questionIcon":"index-module_questionIcon_fLt1g"};